module.exports = __webpack_public_path__ + "static/pagezoom-dfbeb36ee0fb2badac1a1777ff124540.png";